import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import axios from "axios";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PriceInput from "../Product/PriceInput";
interface fees {
    branchId: string;
    fees: number;
}
interface ServiceFeesProps {
    branchId?: string;
}
export default function ServiceFees({ branchId }: ServiceFeesProps) {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [serviceFees, setServiceFees] = useState<fees[]>([]); // Adjust type as needed
    useLockBodyScroll(modalOpen);
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    async function getServiceFees() {
        if (!branchId) return;
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/settings/internal-service-fees?branchId=${branchId}`,
                method: "GET",
                headers: {
                    Authorization: token,
                }
            };
            const response = await axios.request(options);
            if (response.data.success) {
                setServiceFees(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching service fees:", error);
        }
    }
    async function saveServiceFees() {
        if (!branchId) return;
        const toastId = toast.loading(t("serviceFees.saving"));
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/settings/internal-service-fees`,
                method: "PUT",
                headers: {
                    Authorization: token,
                },
                data: {
                    branchId: branchId,
                    fees: serviceFees[0]?.fees || 0 // Ensure fees is a string
                }
            };
            const response = await axios.request(options);
            if (response.data.success) {
                toast.success(t("serviceFees.success"));
                toggleModal()
            }
        } catch (error) {
            console.error("Error fetching service fees:", error);
            toast.error(t("serviceFees.error"), { id: toastId });
        } finally {
            toast.dismiss(toastId);
        }
    }
    useEffect(() => {
        if (branchId) {
            getServiceFees();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId, modalOpen]);


    return (
        <>
            {modalOpen && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
                    <div className="w-fit max-w-2xl rounded-lg bg-white p-5 flex md:min-w-[30%] min-w-[80%] flex-col gap-3 shadow-lg">
                        <X className=" self-end cursor-pointer text-red-600" size={24} onClick={toggleModal} />
                        <h2 className="text-lg font-semibold text-center">{t("serviceFees.title")}</h2>
                        <PriceInput
                            value={serviceFees[0]?.fees ?? ""}
                            onChange={(value) => {
                                setServiceFees([
                                    { branchId: branchId!, fees: value },
                                    ...serviceFees.slice(1)
                                ]);
                            }}
                            place="modal"
                        />


                        <div className="flex items-center justify-end gap-2 mt-3">
                            <button onClick={saveServiceFees} className="my-btn w-fit px-5">{t("buttons.save")}</button>
                            <button onClick={toggleModal} className="my-btn bg-red-600 text-white hover:bg-red-600 w-fit px-5">{t("buttons.cancel")}</button>
                        </div>
                    </div>
                </div>
            )}

            <button onClick={toggleModal} className="flex items-center justify-center gap-2 rounded-md border border-border bg-sidebar px-3 py-1 text-lg font-semibold text-skyblue md:gap-3">
                {t("serviceFees.button")}
            </button>
        </>
    )
}
